import IntegrationComponentRegistry from "src/integrations/IntegrationComponentRegistry";

export default function useComponentOverride(type) {
  const Component = IntegrationComponentRegistry.getComponent(type)?.Component;

  return {Component};
}
